import { Translation, TranslationCollection } from "./translation";

export interface DocumentArchiveModel {
    searchResult: Document[];
    mainDocumentFilter: DocumentFilter;
    documentFilters: DocumentFilter[];
}

export interface DocumentFilter {
    id: string;
    title: string;
    documentFilterOptions: DocumentFilterOption[];
}

export interface DocumentFilterOption {
    filterType: number;
    id: string;
    name: string;
    count: number;
}

export interface Document {
    id: string;
    name: string;
    url: string;
    downloadUrl: string;
    iconUrl: string;
}

export interface DocumentSearchModel {
    mainFilterOption: DocumentFilterOption;
    selectedFilterOptions: DocumentFilterOption[];
}

export interface DocumentArchiveTranslations extends TranslationCollection {
    pageTitleHeading: string;
    pageTitleText: string;
    downloadButtonText: string;
    mainFilterSelectorPlaceHolder: string;
}

export enum DocumentFilterType {
    DocumentType = 0,
    Group = 1,
    Category = 2
}
